<template>
  <div>
    <nav class="h-12 w-full flex items-center gap-2 px-4 border-b border-border bg-background">
      <button
        type="button"
        class="relative z-10 flex shrink-0 items-center justify-center h-8 w-8 rounded-md text-foreground hover:bg-muted transition-colors"
        :aria-label="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        @click="$emit('toggle-sidebar')"
      >
        <PanelLeft :size="20" />
      </button>
      <div class="h-5 w-px bg-border shrink-0" />
      <div class="flex-1 min-w-0">
        <slot name="title" />
      </div>
      <div class="flex items-center gap-2">
        <slot name="actions" />
      </div>
    </nav>
    <slot name="below" />
  </div>
</template>

<script>
import { PanelLeft } from 'lucide-vue-next'

export default {
  name: 'TopbarShell',
  components: { PanelLeft },
  props: {
    collapsed: { type: Boolean, default: false },
  },
  emits: ['toggle-sidebar'],
}
</script>
